export const SpacingSize = {
  NONE: "none",
  DEFAULT: "default",
  ONE: "one",
};
